/* Geo-detection automatica: forza country IT per visitor con browser italiano
   ma con geo-IP ambiguo (datacenter, VPN, IP non riconosciuto come italiano).
   Evita che il dropdown country del checkout pre-selezioni un paese sbagliato (Austria).
   Si esegue UNA volta per sessione (cookie).
*/
(function(){
  'use strict';
  var COOKIE = 'gdr_geo_set';

  function hasCookie(name){
    return document.cookie.split(';').some(function(c){ return c.trim().indexOf(name + '=') === 0; });
  }
  function setCookie(name, value, days){
    var d = new Date(); d.setTime(d.getTime() + days*24*60*60*1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  if (hasCookie(COOKIE)) return; // già processato in questa sessione

  var lang = (navigator.language || navigator.userLanguage || '').toLowerCase();
  var isItalian = lang.indexOf('it') === 0; // it, it-IT, it-CH, ecc.

  if (!isItalian) {
    // Per non-italiani, lascia che Shopify geo-IP detection faccia il suo (di solito è preciso)
    setCookie(COOKIE, 'skip', 30);
    return;
  }

  // Verifica se Shopify ha già rilevato IT come country (via localization global liquid var)
  // Se non c'è modo di saperlo da JS, faccio comunque POST a /localization.
  // È idempotente: se è già IT, non cambia nulla.
  var fd = new FormData();
  fd.append('form_type', 'localization');
  fd.append('_method', 'put');
  fd.append('country_code', 'IT');
  fd.append('return_to', window.location.pathname + window.location.search);

  fetch('/localization', {
    method: 'POST',
    body: fd,
    credentials: 'include',
    redirect: 'manual',
  }).then(function(){
    setCookie(COOKIE, 'IT', 30);
  }).catch(function(){
    setCookie(COOKIE, 'err', 1); // retry domani
  });
})();
